class SearchController {
    /*@ngInject*/
    constructor($log, SearchService) {
        $log.debug('SearchController initialized');
        this.$log = $log;
        this.searchService = SearchService;
        this.searchTerm = '';
    }

    init(productsText, suggestionsText, searchResultsPictureWidth) {
        this.searchService.setProductsText(productsText);
        this.searchService.setSuggestionsText(suggestionsText);
        this.searchService.setSearchResultsPictureWidth(searchResultsPictureWidth);
    }

    hasFocus() {
        return this.searchService.getFocus();
    }

    focus() {
        this.searchService.addFocus();
    };

    blur() {
        this.searchService.removeFocus();
    };

    keypress() {
        this.searchService.requestSuggestions(this.searchTerm);
    }
}

export default SearchController;
